import * as React from "react";
import { IReportGenerated2 } from "source/models/report/reportGenerated2";
import { ExcelReportDataContainer } from "./ReportExcelReportstyles";
import { Paper } from "@mui/material";
import { ReportExcelReportTables } from "./ReportExcelReportTables/ReportExcelReportTables";

export interface IReportExcelReportProp {
    reportData: IReportGenerated2;
    sortingDisabled: boolean;
    sortColumn: string;
    sortOrderIsAsc: boolean;
    multiSelect?: boolean;
    selectedId?: string;
    checkedIds?: string[];
    margin?: string;
    height?: string;
    minHeight?: string;
    onSetSortData: (sortColumn: string, sortOrderIsAsc: boolean) => void;
    onSetSelectedIds?: (selectedId: string, checkedIds: string[]) => void;
}

export class ReportExcelReport extends React.Component<IReportExcelReportProp, {}> {
    render() {
        const props = this.props;
        if (!props.reportData) return null;
        return (
            <Paper elevation={3} sx={{ margin: props.margin ?? "0 24px 24px 24px", height: props.height ?? "calc(100% - 24px)", minHeight: props.minHeight, overflowY: "auto", overflowX: "auto" }}>
                <ExcelReportDataContainer className={"jsonFormLineData excelLines" + (props.reportData.listWidth > 100.01 ? " w-p" + props.reportData.listWidth.toString(10) : "")}>
                    <ReportExcelReportTables
                        reportData={props.reportData}
                        multiSelect={props.multiSelect}
                        selectedId={props.multiSelect ? props.selectedId : ""}
                        checkedIds={props.multiSelect ? props.checkedIds : []}
                        sortColumn={props.sortColumn}
                        sortOrderIsAsc={props.sortOrderIsAsc}
                        sortingDisabled={props.sortingDisabled}
                        onSetSortData={props.onSetSortData}
                        onSetSelectedIds={props.multiSelect ? props.onSetSelectedIds : null}
                    />
                </ExcelReportDataContainer>
            </Paper>
        );
    }
}